import {
  OuiButtonComponent,
  OuiDividerComponent,
  OuiRowComponent,
  OuiStackComponent,
  OuiTextComponent,
  OuiThemeSwitcherComponent,
} from '@aiz-gl/omni-ui';
import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BasePageComponent } from '../base/base.component';

@Component({
  selector: 'app-user-profile',
  imports: [
    OuiTextComponent,
    OuiButtonComponent,
    OuiRowComponent,
    OuiDividerComponent,
    OuiThemeSwitcherComponent,
    OuiStackComponent,
  ],
  templateUrl: './user-profile.component.html',
})
export class UserProfilePage extends BasePageComponent {
  protected readonly environment = environment;
}
